import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  unstable_HistoryRouter as HistoryRouter,
} from "react-router-dom";
import NotFound from "../screens/NotFound/NotFound";
import CreateUser from "../screens/Landlord/Auth/CreateUser";
import LoginUser from "../screens/Landlord/Auth/LoginUser";
import LandLordDashboard from "../screens/Landlord/Dashboard/Dashboard";
import NewRequest from "../screens/Landlord/NewRequest/NewRequest";
import RequestUserDetail from "../screens/Landlord/RequestUserDetail/RequestUserDetail";
import BankDetail from "../screens/Landlord/BankDetail/BankDetail";
import Profile from "../screens/Landlord/Profile/Profile";
import Agreement from "../screens/Landlord/Agreement/Agreements";
import LandlordFunctionality from "../screens/Landlord/LandlordFunction/LandlordFunctionality";
import AddNew from "../screens/Landlord/AddNewTenant/AddNew";
import TenantFunctionality from "../screens/Tenant/TenantFunction/TenantFunctionality";
import PreviousBill from "../screens/Tenant/PreviousBill/PreviousBill";
import PreviousBillLandlordPage from "../screens/Landlord/PreviousBills/PreviousBill";
import PendingBillLandlordPage from "../screens/Landlord/PendingBill/PendingBill";
import OwnerRegistration from "../screens/Landlord/OwnerRegistration/OwnerRegistration";
import LandingPage from "../screens/LandingPage/LandingPage";
import AboutUs from "../screens/AboutUs/AboutUs";
import { useSelector, useDispatch } from "react-redux";
import TenantDashboard from "../screens/Tenant/TenantDashboard/TenantDashboard";
import TenantAgreements from "../screens/Tenant/TenantAgreement/TenantAgreement";
import CurrentBill from "../screens/Tenant/CurrentBills/CurrentBill";
import axios from "axios";

import { ValidateUser } from "../redux/reducer/ValidateUser";
import { ValidateAdmin } from "../redux/reducer/AdminAuth";
import SkeletonComponent from "../components/SkeletonLoader";
import { createBrowserHistory } from "history";
import TenantRegisteration from "../screens/Tenant/Register/TenantRegisteration";
import NotificationsPage from "../screens/Landlord/Notification/Notification";
import UploadBillTwo from "../screens/Landlord/UploadBills/UploadBill_two";
import MyProperty from "../screens/Landlord/MyProperty/MyProperty";
import ForgotPassword from "../screens/Landlord/Auth/ForgotPassword";
import ResetPassword from "../screens/Landlord/Auth/ResetPassword";
import TenantMaintenanceRequest from "../screens/Tenant/TenantMaintenanceRequest/TenantMaintenanceRequest";
import LandlordMaintenanceRequest from "../screens/Landlord/LandlordMaintenanceRequest/LandlordMaintenanceRequest";
import AdminLogin from "../screens/Admin/AdminLogin";
import AdminDashboard from "../screens/Admin/Dashboard/AdminDashboard";
import UserManagement from "../screens/Admin/Users/UserManagement";
import LandlordManagement from "../screens/Admin/Landlords/LandlordManagement";
import PropertyManagement from "../screens/Admin/Properties/PropertyManagement";
import TenantManagement from "../screens/Admin/Tenants/TenantManagement";
import RevenueManagement from "../screens/Admin/Revenue/RevenueManagement";
import AdminReports from "../screens/Admin/Reports/AdminReports";
import AdminSettings from "../screens/Admin/Settings/AdminSettings";
import AdminManagement from "../screens/Admin/AdminManagement/AdminManagement";
import ActivityLogs from "../screens/Admin/ActivityLogs/ActivityLogs";
import SearchProperty from "../screens/Tenant/SearchProperty/SearchProperty";
import PaymentSuccess from "../screens/Payment/PaymentSuccess";
import PaymentCancel from "../screens/Payment/PaymentCancel";
import InterestRequests from "../screens/Landlord/InterestRequests/InterestRequests";
import MyRequests from "../screens/Tenant/MyRequests/MyRequests";
import RentalHistory from "../screens/Tenant/RentalHistory/RentalHistory";
import MyTenants from "../screens/Landlord/MyTenants/MyTenants";
import TenantProfileEdit from "../screens/Tenant/TenantProfile/TenantProfileEdit";
import RentTracker from "../screens/Landlord/RentTracker/RentTracker";
import PublicSearchProperty from "../screens/PublicSearch/PublicSearchProperty";
import AdminRouteGuard from "../components/AdminRouteGuard";
import { PERMISSIONS, getAdminHomePath } from "../config/adminRoles";
import TenantRentBills from "../screens/Tenant/RentPayment/TenantRentBills";
import EscrowDashboard from "../screens/Landlord/EscrowManagement/EscrowDashboard";
import CommissionSettings from "../screens/Admin/Settings/CommissionSettings";
import OtsFeeReceipts from "../screens/Admin/OtsFeeReceipts/OtsFeeReceipts";
import TenantFunnel from "../screens/Admin/TenantFunnel/TenantFunnel";
import MoveOuts from "../screens/Admin/MoveOuts/MoveOuts";
import OwnerPayouts from "../screens/Admin/OwnerPayouts/OwnerPayouts";
import ViolationEscalations from "../screens/Admin/ViolationEscalations/ViolationEscalations";
import PropertyReviews from "../screens/Admin/PropertyReviews/PropertyReviews";
import Wallet from "../screens/Landlord/Wallet/Wallet";
import UnregisterTenantPage from "../screens/Landlord/UnRegisterTenant/UnregisterTenantPage";
import UnregisterTenantRequestPage from "../screens/Tenant/UnRegisterTenant/UnregisterTenantRequestPage";
import PropertySetting from "../screens/Landlord/PropertySettings/PropertySetting";

export default function AllRoutes() {
  const dispatch = useDispatch();
  const history = createBrowserHistory();
  const [load, setLoad] = useState(false);
  const { loginUser, validateUser, adminAuth } = useSelector((state) => state);
  // Where an admin lands: the first page their role can open (not always the
  // dashboard — support and finance roles open different pages)
  const adminHomePath =
    getAdminHomePath(
      validateUser?.UserValidate?.data?.user || loginUser?.login?.data?.data
    ) || "/admin-dashboard";
  const localtoken = loginUser?.login?.data?.accessToken;
  const token = sessionStorage.getItem("ots_token") || localtoken;

  // Check if logged in user is admin
  const userType = loginUser?.login?.data?.data?.type;
  const isAdminUser =
    userType === "admin" || adminAuth?.admin?.type === "admin";

  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  useEffect(() => {
    if (token) {
      setLoad(true);
      // Use different validation endpoint based on user type
      // Admin uses /admin/me, others use /validateUser
      if (isAdminUser) {
        dispatch(ValidateAdmin()).finally(() => {
          setLoad(false);
        });
      } else {
        dispatch(ValidateUser({ loginToken: token })).finally(() => {
          setLoad(false);
        });
      }
    }
  }, [dispatch, token, isAdminUser]);

  function Redirect({ to }) {
    let navigate = useNavigate();

    useEffect(() => {
      navigate(to);
    }, [navigate, to]);

    return null;
  }

  // if (registeredUser === null) {
  //   return (
  //     <Router>
  //       <Routes>
  //         <Route path="/" element={<LandingPage />} />
  //         <Route path="/login" element={<LoginUser />} />
  //         <Route path="/signup" element={<CreateUser />} />
  //         <Route path="/*" element={<NotFound />} />
  //       </Routes>
  //     </Router>
  //   );
  // } else
  if (load) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<SkeletonComponent />} />
        </Routes>
      </Router>
    );
  } else if (
    loginUser?.login?.data?.message === "No User Found" ||
    loginUser?.login?.data?.message === "Invalid User Login" ||
    (loginUser?.login?.length === 0 &&
      validateUser?.UserValidate?.length === 0 &&
      !token)
  ) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/search-property" element={<PublicSearchProperty />} />
          <Route path="/login" element={<LoginUser />} />
          <Route path="/signup" element={<CreateUser />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/signup/:id?" element={<CreateUser />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/*" element={<Redirect to="/login" />} />
        </Routes>
      </Router>
    );
  }
  // else if (
  //   (loginUser?.login?.data?.data?.is_register === true &&
  //     loginUser?.login?.data?.data?.is_active === false) ||
  //   (validateUser?.UserValidate?.data?.user?.is_register === true &&
  //     validateUser?.UserValidate?.data?.user?.is_active === false)
  // ) {
  //   return (
  //     <Router>
  //       <Routes>
  //         {/* <Route path="/" element={<LandingPage />} />
  //         <Route path="/signup/:id?" element={<CreateUser />} />
  //         <Route path="/login" element={<LoginUser />} /> */}
  //         <Route path="/pending-request" element={<PendingRequest />} />
  //         {loginUser?.login?.data?.data?.type === "landlord" ||
  //         validateUser?.UserValidate?.data?.user?.type === "landlord" ? (
  //           <Route path="/*" element={<Redirect to="/pending-request" />} />
  //         ) : loginUser?.login?.data?.data?.type === "tenant" ||
  //           validateUser?.UserValidate?.data?.user?.type === "tenant" ? (
  //           <Route path="/*" element={<Redirect to="/pending-request" />} />
  //         ) : (
  //           <Route path="/*" element={<NotFound />} />
  //         )}
  //       </Routes>
  //     </Router>
  //   );
  // }
  else if (
    (loginUser?.login?.data?.data?.is_register === true &&
      loginUser?.login?.data?.data?.is_active === true) ||
    (validateUser?.UserValidate?.data?.user?.is_register === true &&
      validateUser?.UserValidate?.data?.user?.is_active === true) ||
    // Admin users should always get authenticated routes regardless of is_register/is_active
    loginUser?.login?.data?.data?.type === "admin" ||
    validateUser?.UserValidate?.data?.user?.type === "admin" ||
    // Also check adminAuth state (from ValidateAdmin /admin/me response)
    adminAuth?.isAuthenticated ||
    adminAuth?.admin?.type === "admin"
  ) {
    //  return <Menus />
    return (
      <HistoryRouter history={history}>
        {/* <Router> */}
        <Routes>
          {/* {useTrackPath()} */}
          <Route path="/landlord-dashboard" element={<LandLordDashboard />} />
          {/* Admin Routes - Protected with AdminRouteGuard */}
          <Route
            path="/admin-dashboard"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_DASHBOARD}>
                <AdminDashboard />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_USERS}>
                <UserManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/landlords"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_LANDLORDS}>
                <LandlordManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/properties"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_PROPERTIES}>
                <PropertyManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/tenants"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_TENANTS}>
                <TenantManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/revenue"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_REVENUE}>
                <RevenueManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_REPORTS}>
                <AdminReports />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/ots-fee-receipts"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VERIFY_PAYMENTS}>
                <OtsFeeReceipts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/tenant-funnel"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VERIFY_PAYMENTS}>
                <TenantFunnel />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/move-outs"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_PROPERTIES}>
                <MoveOuts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/payouts"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.MANAGE_PAYOUTS}>
                <OwnerPayouts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/violation-escalations"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.REVIEW_VIOLATION_ESCALATIONS}>
                <ViolationEscalations />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/property-reviews"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.MODERATE_REVIEWS}>
                <PropertyReviews />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_SETTINGS}>
                <AdminSettings />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/commission-settings"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.EDIT_SETTINGS}>
                <CommissionSettings />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/manage-admins"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_ADMINS}>
                <AdminManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/activity-logs"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_ACTIVITY_LOGS}>
                <ActivityLogs />
              </AdminRouteGuard>
            }
          />
          <Route path="/new-request" element={<NewRequest />} />
          <Route
            path="/maintenance-request"
            element={<LandlordMaintenanceRequest />}
          />
          <Route path="/user-detail" element={<RequestUserDetail />} />
          <Route path="/my-tenants" element={<MyTenants />} />
          {/* <Route path="/rent-setting" element={<RentSetting />} /> */}
          {/* <Route path="/bank-detail" element={<BankDetail />} /> */}
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/my-properties" element={<MyProperty />} />
          <Route path="/properties-setting" element={<PropertySetting />} />
          <Route path="/rent-tracker" element={<RentTracker />} />
          {/* Rent collection is the rent tracker now — both read the same rent bills. */}
          <Route path="/rent-collection" element={<RentTracker />} />
          <Route path="/escrow-management" element={<EscrowDashboard />} />
          <Route path="/interest-requests" element={<InterestRequests />} />
          <Route
            path="/landlord-functionality/:id?/:id?"
            element={<LandlordFunctionality />}
          />
          <Route
            path="/unregister-tenant/:id?/:id?"
            element={<UnregisterTenantPage />}
          />
          <Route
            path="/unregister-tenant-request/:id?/:id?"
            element={<UnregisterTenantRequestPage />}
          />
          <Route
            path="/tenant-functionality/:id?/:id?"
            element={<TenantFunctionality />}
          />
          <Route path="/agreement/:id?/:id?" element={<Agreement />} />
          {/* <Route
            path="/upload-Bill/:tenantId?/:flatId?"
            element={<UploadBill />}
          /> */}
          <Route
            path="/upload-Bill/:tenantId?/:flatId?"
            element={<UploadBillTwo />}
          />
          <Route
            path="/previous-bill/:id?/:id?"
            element={<PreviousBillLandlordPage />}
          />
          <Route
            path="/pending-bill/:id?/:id?"
            element={<PendingBillLandlordPage />}
          />
          {/* <Route path="/property-reg" element={<PropertyRegister />} /> */}

          <Route path="/add-new-tenant" element={<AddNew />} />
          {/* <Route path="/chat" element={<Chat />} /> */}
          {/* <Route path="/property-reg" element={<PropertyRegister />} /> */}
          {/* <Route path="/tenant-registration" element={<Registeration />} /> */}
          <Route path="/tenant-dashboard" element={<TenantDashboard />} />
          <Route path="/tenant-profile" element={<TenantProfileEdit />} />
          <Route path="/find-property" element={<SearchProperty />} />
          <Route path="/my-requests" element={<MyRequests />} />
          <Route path="/rental-history" element={<RentalHistory />} />
          <Route path="/rent-payment" element={<TenantRentBills />} />
          <Route
            path="/current-Bill/:landlordId?/:flatId?"
            element={<CurrentBill />}
          />
          <Route
            path="/previous-TenantBill/:landlordId?/:flatId?"
            element={<PreviousBill />}
          />
          <Route path="/about-us" element={<AboutUs />} />
          <Route
            path="/tenant-agreement/:id?/:id?"
            element={<TenantAgreements />}
          />
          <Route
            path="/tenant-maintenance-request/:id?/:id?"
            element={<TenantMaintenanceRequest />}
          />
          {/* Payment Routes */}
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          {/* <Route path="/Landing-page" element={<LandingPage />} /> */}
          {loginUser?.login?.data?.data?.type === "landlord" ||
          validateUser?.UserValidate?.data?.user?.type === "landlord" ? (
            <Route path="/*" element={<Redirect to="/landlord-dashboard" />} />
          ) : loginUser?.login?.data?.data?.type === "admin" ||
            validateUser?.UserValidate?.data?.user?.type === "admin" ? (
            <Route path="/*" element={<Redirect to={adminHomePath} />} />
          ) : (
            <Route path="/*" element={<Redirect to="/tenant-dashboard" />} />
          )}
        </Routes>
        {/* </Router> */}
      </HistoryRouter>
    );
  } else if (
    (loginUser?.login?.data?.data?.is_register === false &&
      loginUser?.login?.data?.data?.is_active === false) ||
    (validateUser?.UserValidate?.data?.user?.is_register === false &&
      validateUser?.UserValidate?.data?.user?.is_active === false)
  ) {
    return (
      <Router>
        <Routes>
          {/* <Route path="/" element={<LandingPage />} /> */}
          {/* <Route path="/signup/:id?" element={<CreateUser />} /> */}
          {/* <Route path="/login" element={<LoginUser />} /> */}
          <Route path="/owner-registration" element={<OwnerRegistration />} />
          {/* <Route path="/tenant-registration" element={<Registeration />} /> */}
          <Route
            path="/tenant-registration"
            element={<TenantRegisteration />}
          />
          {loginUser?.login?.data?.data?.type === "landlord" ||
          validateUser?.UserValidate?.data?.user?.type === "landlord" ? (
            <Route path="/*" element={<Redirect to="/owner-registration" />} />
          ) : loginUser?.login?.data?.data?.type === "tenant" ||
            validateUser?.UserValidate?.data?.user?.type === "tenant" ? (
            <Route path="/*" element={<Redirect to="/tenant-registration" />} />
          ) : (
            <Route path="/*" element={<NotFound />} />
          )}
        </Routes>
      </Router>
    );
  } else if (token) {
    // Fallback: If token exists but no other condition matched, show authenticated routes
    // Determine user type for proper redirect
    const userType =
      loginUser?.login?.data?.data?.type ||
      validateUser?.UserValidate?.data?.user?.type;

    const getDefaultRedirect = () => {
      if (userType === "admin") return adminHomePath;
      if (userType === "landlord") return "/landlord-dashboard";
      if (userType === "tenant") return "/tenant-dashboard";
      return "/login"; // Fallback to login if type unknown
    };

    return (
      <HistoryRouter history={history}>
        <Routes>
          <Route path="/landlord-dashboard" element={<LandLordDashboard />} />
          {/* Admin Routes - Protected with AdminRouteGuard */}
          <Route
            path="/admin-dashboard"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_DASHBOARD}>
                <AdminDashboard />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_USERS}>
                <UserManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/landlords"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_LANDLORDS}>
                <LandlordManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/properties"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_PROPERTIES}>
                <PropertyManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/tenants"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_TENANTS}>
                <TenantManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/revenue"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_REVENUE}>
                <RevenueManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_REPORTS}>
                <AdminReports />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/ots-fee-receipts"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VERIFY_PAYMENTS}>
                <OtsFeeReceipts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/tenant-funnel"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VERIFY_PAYMENTS}>
                <TenantFunnel />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/move-outs"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_PROPERTIES}>
                <MoveOuts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/payouts"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.MANAGE_PAYOUTS}>
                <OwnerPayouts />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/violation-escalations"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.REVIEW_VIOLATION_ESCALATIONS}>
                <ViolationEscalations />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/property-reviews"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.MODERATE_REVIEWS}>
                <PropertyReviews />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_SETTINGS}>
                <AdminSettings />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/manage-admins"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_ADMINS}>
                <AdminManagement />
              </AdminRouteGuard>
            }
          />
          <Route
            path="/admin/activity-logs"
            element={
              <AdminRouteGuard requiredPermission={PERMISSIONS.VIEW_ACTIVITY_LOGS}>
                <ActivityLogs />
              </AdminRouteGuard>
            }
          />
          <Route path="/tenant-dashboard" element={<TenantDashboard />} />
          <Route path="/tenant-profile" element={<TenantProfileEdit />} />
          <Route path="/find-property" element={<SearchProperty />} />
          <Route path="/my-requests" element={<MyRequests />} />
          <Route path="/rental-history" element={<RentalHistory />} />
          <Route path="/rent-payment" element={<TenantRentBills />} />
          <Route
            path="/current-Bill/:landlordId?/:flatId?"
            element={<CurrentBill />}
          />
          <Route
            path="/previous-TenantBill/:landlordId?/:flatId?"
            element={<PreviousBill />}
          />
          <Route
            path="/tenant-agreement/:id?/:id?"
            element={<TenantAgreements />}
          />
          <Route
            path="/tenant-maintenance-request/:id?/:id?"
            element={<TenantMaintenanceRequest />}
          />
          <Route path="/new-request" element={<NewRequest />} />
          <Route
            path="/maintenance-request"
            element={<LandlordMaintenanceRequest />}
          />
          <Route path="/user-detail" element={<RequestUserDetail />} />
          <Route path="/my-tenants" element={<MyTenants />} />
          {/* <Route path="/bank-detail" element={<BankDetail />} /> */}
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/my-properties" element={<MyProperty />} />
          <Route path="/properties-setting" element={<PropertySetting />} />
          <Route path="/rent-tracker" element={<RentTracker />} />
          {/* Rent collection is the rent tracker now — both read the same rent bills. */}
          <Route path="/rent-collection" element={<RentTracker />} />
          <Route path="/escrow-management" element={<EscrowDashboard />} />
          <Route path="/interest-requests" element={<InterestRequests />} />
          <Route
            path="/landlord-functionality/:id?/:id?"
            element={<LandlordFunctionality />}
          />
          <Route
            path="/unregister-tenant/:id?/:id?"
            element={<UnregisterTenantPage />}
          />
          <Route
            path="/unregister-tenant-request/:id?/:id?"
            element={<UnregisterTenantRequestPage />}
          />
          <Route
            path="/tenant-functionality/:id?/:id?"
            element={<TenantFunctionality />}
          />
          <Route path="/agreement/:id?/:id?" element={<Agreement />} />
          <Route
            path="/upload-Bill/:tenantId?/:flatId?"
            element={<UploadBillTwo />}
          />
          <Route
            path="/previous-bill/:id?/:id?"
            element={<PreviousBillLandlordPage />}
          />
          <Route
            path="/pending-bill/:id?/:id?"
            element={<PendingBillLandlordPage />}
          />
          <Route path="/add-new-tenant" element={<AddNew />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/*" element={<Redirect to={getDefaultRedirect()} />} />
        </Routes>
      </HistoryRouter>
    );
  } else {
    // Final fallback: No token, show login
    return (
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginUser />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/*" element={<Redirect to="/login" />} />
        </Routes>
      </Router>
    );
  }
}
